<template>
  <div class="ce-searchFilter-industry">
    <label>{{ label }}</label>
    <div class="flex flex-wrap mxn1">
      <div
        class="m1"
        v-for="industry in options"
        :key="industry.code"
        :class="{selected: industry.selected, disabled: industry.disabled}"
        @click.prevent="toggle(industry)">
        <tooltip
          :content="industry.title"
          placement="bottom">
          <img
            v-if="industry.image"
            :src="industry.image.squarePreview.src"
            :alt="industry.title">
          <template v-else>
            <fa-icon icon="industry" />
          </template>
        </tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneObject } from 'utils';
import SearchConfig from '@sun-chemical/system-config/search-config';

export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    filterKey: {
      type: String,
      required: false,
      default: null
    },
  },
  computed: {
    ...mapGetters(['urlFilters', 'filters'])
  },
  methods: {
    toggle(industry) {
      if (industry.disabled) return;
      this.$trackEvent('filter', 'toggle', {
        filterType: 'industry',
        filterKey: this.filterKey,
        filterLabel: this.label,
        value: industry.title
      });

      const industries = cloneObject(this.options);
      const toChange = industries.find((i) => i.code === industry.code);
      toChange.selected = !toChange.selected;

      const activeIndustries = industries.filter((i) => i.selected).map((i) => i.code);
      const url = cloneObject(this.urlFilters);
      const { param } = SearchConfig.getMap().industry;

      // Reset all non-generic url params
      const genericFilterParams = Object.values(this.filters.generic).map((f) => f.param);
      genericFilterParams.push(SearchConfig.getMap().search_term.param);
      genericFilterParams.push('tab');
      Object.keys(url).forEach((urlParam) => {
        if (genericFilterParams.indexOf(urlParam) === -1) {
          delete url[urlParam];
        }
      });

      if (activeIndustries.length > 0) url[param] = activeIndustries;
      else delete url[param];

      this.$store.dispatch('setUrlFilters', url);
    }
  }
};
</script>

<style lang="less">
  @import (reference) '~styles/includes/base';
  .ce-searchFilter-industry {
    > div {
      > div {
        width: 44px;
        height: 44px;
        border-radius: @border-radius;
        word-break: break-all;
        cursor: pointer;
        box-shadow: 2px 2px 4px fade(@color-mono-10, 20);

        span {
          display: block;
          border-radius: @border-radius;
          transition: all 250ms ease-in-out;

          img {
            border-radius: (@border-radius - 3);
          }
        }

        &.selected {
          div.v-popper {
            .ce-selectedBadge;
          }
        }

        &.disabled {
          img {
            opacity: 0.2;
            cursor: not-allowed;
          }
        }

        img {
          display: block;
          max-width: 100%;
          transition: all 250ms ease-in-out;
        }
      }
    }
  }
</style>
